export const Config = {
  headers: {
    'Content-Type': 'application/json',
    'Accept': '*/*'
  },

  baseUrl: import.meta.env.VITE_BACKEND_BASE_URL,
  store: 'store/',
  settings: 'settings',
  user: 'user/',

  payment: 'payment/',
  session: 'session',
  verify: 'verify',

  upload: 'upload',

  locations: 'locations',
  location: 'location/',
  cartLayouts: 'cart_layouts',
  cartLayout: 'cart_layout/',
  zones: 'zones',
  zone: 'zone/'
}